<template>
  <div class="report-referred-request">

    <v-row class="report-date-picker">
      <div class="col-6">
        <v-text-field
          :placeholder="$t('search_phone')"
          v-model="seach_input_mobile"
          class="mr-2 ml-2"
          append-icon="mdi-magnify"
          outlined
          @click:append="click_search"
        ></v-text-field>
      </div>
      <div class="col-6">
        <v-text-field
          placeholder="جستجو کد"
          v-model="seach_input_code"
          class="mr-2 ml-2"
          append-icon="mdi-magnify"
          outlined
          @click:append="click_search"
        ></v-text-field>
      </div>
    </v-row>
    <v-row>


    </v-row>
    <div>
      <!--        <v-row-->
      <!--          v-for="(item, i) in request_items"-->
      <!--          :key="i"-->
      <!--          cols="12"-->
      <!--        >-->
      <!--          <v-col cols="12">-->
      <div v-for="(item, i) in request_items"
           :key="i"
           class="req-item"
      >
        <v-card v-on:click="goToDetail(item)">
          <v-card-title class="headline req-title">
            {{ $t('requestNoQ') }} {{item.RequestCode}}
          </v-card-title>

          <div class="req-date">
            {{ $t('referDateQ') }} {{item.ReferDate}}

          </div>
          <div class="req">
            {{ $t('requestNameQ') }} {{item.RequestName}}
          </div>
          <div class="req">
            {{item.StateName}}
          </div>
          <div class="address" v-if="get_request_address(item) != ''">
            {{ $t('addressQ') }}
            {{get_request_address(item)}}
          </div>
          <v-card-actions>
            <v-btn text class="last-status">
              {{item.LastStatus}}
            </v-btn>

          </v-card-actions>
        </v-card>
      </div>

      <!--          </v-col>-->
      <!--        </v-row>-->
      <vue-context ref="menu">
        <li>
          <a href="#" @click.prevent="">{{ $t('receiveSignature') }}</a>
        </li>
        <li>
          <a href="#" @click.prevent="context_menu_clicked('payments')">{{ $t('pays') }}</a>
        </li>
      </vue-context>
    </div>

  </div>

</template>
<script>
  import Vue from 'vue'
  import moment from 'moment-jalaali'

  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
  import VueContext from 'vue-context'
  import 'vue-context/src/sass/vue-context.scss'

  Vue.component('date-picker', VuePersianDatetimePicker)
  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        errors: [],

        seach_input_mobile: '',
        seach_input_code: '',
        request_items: [],
        clicked_request_context: null,
      }
    },
    components: {
      datePicker: VuePersianDatetimePicker,
      VueContext,
    },
    watch: {
      // 'start_date': function () {
      //
      // },
      // 'end_date': function () {
      //   this.get_report(0);
      //
      // },

    },
    mounted() {
      this.start_date = moment().utc().subtract(3, 'months').format('jYYYY/jMM/jDD')
      this.end_date = moment().utc().format('jYYYY/jMM/jDD')
      this.get_report(0)
    },
    methods: {
      click_search() {
        console.log('clcked')
        this.get_report(0)
      },
      open_context_menu(item) {
        var self = this
        var click_event = event
        this.clicked_request_context = item
        setTimeout(function () {
          self.$refs.menu.open(click_event, null)
        }, 150)
      },
      context_menu_clicked(func) {
        if (func == 'payments') {
          this.$router.push({path: '/report-request/add-price-result/' + this.clicked_request_context.RecId})
        }
      },
      get_request_address(item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' '
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' '
        }
        if (item.AddressText != null) {
          address += item.AddressText + ' '
        }
        return address
      },
      goToDetail(item) {
        console.log('req code is ', item.RequestCode, item)

        if (item.ModelId == 0) {
          this.$router.push({name: 'ViewRequestReadOnly', params: {rec_id: item.Id, rec_name: item.RequestCode}})
        } else {
          this.$router.push({name: 'ViewPreRequestReadOnly', params: {rec_id: item.Id}})
        }
      },
      get_report(page) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var mobile = this.seach_input_mobile;
        var code = this.seach_input_code;
        mobile = this.persian_to_english(mobile);
        code = this.persian_to_english(code);

        if (mobile.startsWith("0")) {
          mobile = mobile.substring(1, mobile.length);
        }
        if(mobile!=""){
          code = "";
        }
        const send_data = {
          UserId: user_id,
          SearchName: "",
          SearchMobile: mobile,
          SearchReq: code,
          Page: page,

        }


        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetAllRequestsApp', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.user_registered = true;
              // self.fullName = response.data.msg;
              // self.level = 2;
              if (page == 0) {
                self.request_items = response.data.requests
              } else {
                response.data.refers.forEach(function (number) {
                  self.request_items.push(number)
                })
              }
              self.seach_input_mobile = "";
              self.seach_input_code="";
            } else {
              self.not_register = true
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
<style>
  .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {

    min-height: 40px !important;
  }
</style>
